import React from "react";
import {
  //Banner,
  HomeCourses,
  HowMyCoursesWork,
  // Reviews,
} from "../../../components/Web";
import { CookieConsentBanner } from "../../../components/CookiesBanner/CoockiesBanner";
import { Experience } from "../../../components/Web/AssistanceThreeJs";

//<Banner /> otro component creado para home
export function Home() {
  return (
    <div>
      <Experience />
      <HomeCourses />
      <HowMyCoursesWork />
      {/* <Reviews /> */}
      <CookieConsentBanner />
    </div>
  );
}
